module.exports = __webpack_public_path__ + "static/pursuit-logo-c2323bbc0cbc9faab74bb7b8546877f3.jpeg";